type NullAndOptionalWrapper<T> = Partial<{
  [P in keyof T]: T[P] | null;
}>;

export type UrlParamsStoreState = NullAndOptionalWrapper<{
  participation_uuid: string;
  project_uuid: string;
  is_preview: string;
  auth?: string;
}>;

type Key = keyof UrlParamsStoreState;

function get(property: Key): UrlParamsStoreState[Key] | null;
function get<T extends Key>(properties: T[]): Pick<UrlParamsStoreState, T>;
function get<T extends Key>(
  properties: T | T[],
): UrlParamsStoreState[T] | Pick<UrlParamsStoreState, T> | null {
  const search = new URLSearchParams(window.location.search);

  if (typeof properties === 'string') {
    return search.get(properties);
  }

  return properties.reduce((result, key) => {
    result[key] = search.get(key);
    return result;
  }, {} as UrlParamsStoreState);
}

export const parametersStore = {
  get,
};
